import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { NotFound } from '../../app/routing/NotFound';
import { equipmentFullPath } from '../../pathDefinitions';

const ListEquipmentRoute = lazy(() => import('./list/ListEquipmentRoute'));
const EquipmentDetailsRoute = lazy(
  () => import('./details/EquipmentDetailsRoute')
);
const EquipmentCompanyDetails = lazy(
  () => import('./details/EquipmentCompanyDetails')
);

const ConfigListPage = lazy(
  () => import('../../../feature/deckmapp/admin/configList/ConfigListPage')
);
const ConfigDetailsPreview = lazy(
  () =>
    import('../../../feature/deckmapp/admin/configList/preview/ConfigDetailsRoute')
);
const ConfigDetailsPage = lazy(
  () =>
    import('../../../feature/deckmapp/admin/configDetails/ConfigDetailsPage')
);

export const equipmentIdParam = 'equipmentId';
export const companyIdParam = 'companyId';
export const configIdParam = 'configId';

export const equipmentCompanyRoute = (equipmentId: string, companyId: string) =>
  `${equipmentFullPath}/${equipmentId}/company/${companyId}`;
export const configListRoute = (equipmentId: string) =>
  `${equipmentFullPath}/${equipmentId}/deck/configs`;
export const configDetailsRoute = (equipmentId: string, configId: string) =>
  `${equipmentFullPath}/${equipmentId}/deck/config/${configId}`;

export default function AdminEquipmentRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ListEquipmentRoute />} />
      <Route
        path={`:${equipmentIdParam}`}
        element={<EquipmentDetailsRoute />}
      />
      <Route
        path={`:${equipmentIdParam}/company/:${companyIdParam}`}
        element={<EquipmentCompanyDetails />}
      />
      <Route
        path={`:${equipmentIdParam}/deck/configs`}
        element={<ConfigListPage />}
      />
      <Route
        path={`:${equipmentIdParam}/deck/configs/:${configIdParam}`}
        element={<ConfigDetailsPreview />}
      />
      <Route
        path={`:${equipmentIdParam}/deck/config/:${configIdParam}`}
        element={<ConfigDetailsPage />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
